function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_11733",
  "data-name": "Group 11733",
  transform: "translate(-246 -140)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_11705",
  "data-name": "Group 11705",
  transform: "translate(-794 -178)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_249",
  "data-name": "Ellipse 249",
  cx: 11,
  cy: 11,
  r: 11,
  transform: "translate(1040 318)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_18499",
  "data-name": "Path 18499",
  d: "M65.9,316a8.9,8.9,0,0,0-7.322,3.819,9.494,9.494,0,0,0,14.712-.083C72.36,318.807,70.256,316,65.9,316Zm0,0",
  transform: "translate(984.911 15.04)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_18500",
  "data-name": "Path 18500",
  d: "M169.338,68.789A3.342,3.342,0,0,1,166,65.451V64.338a3.338,3.338,0,1,1,6.676,0v1.113A3.342,3.342,0,0,1,169.338,68.789Zm0,0",
  transform: "translate(881.477 260.582)",
  fill: "#fff"
})));

var SvgResponse = function SvgResponse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResponse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/response.d3ba0afd.svg";
export { ForwardRef as ReactComponent };